import gql from 'graphql-tag'
import { EmployeeFragment } from '@api/fragments'
import { IEmployee } from '@api/types'
import client from '../../stores/apollo'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  deleteEmployeesFromWorkplaceGroup: {
    employees: IEmployee[]
  }
}

export const removeEmployeesFromWorkplaceGroupMutation = gql`
  mutation DeleteEmployeesFromWorkplaceGroup($input: DeleteEmployeesFromWorkplaceGroupInput!) {
    deleteEmployeesFromWorkplaceGroup(input: $input) {
      employees {
        ...EmployeeFragment
      }
    }
  }
  ${EmployeeFragment}
`

const mutateHandler = handleFetchResult<IPayload, IEmployee[]>({
  handler: (data) => data.deleteEmployeesFromWorkplaceGroup.employees,
  name: 'Contract',
})

export default function removeEmployeesFromWorkplaceGroup(
  employeeIds: string[],
  workplaceGroupId?: string
): Promise<IEmployee[]> {
  const input = { employeeIds, workplaceGroupId }

  return client.gql
    .mutate({
      mutation: removeEmployeesFromWorkplaceGroupMutation,
      variables: { input },
    })
    .then(mutateHandler)
}
